import * as api from '../api'
import * as types from '../mutation-types'
import router from '../../router'

const state = {
  advanced_visual: {
    background_color: '#000000'
  },
  advanced_visuals: []
}

const getters = {
  singleAdvancedVisual: state => state.advanced_visual,
  allAdvancedVisuals: state => state.advanced_visuals
}

const actions = {
  getAdvancedVisuals ({ commit, dispatch }) {
    api.instance.get('advanced_visuals')
      .then(function (response) {
        const advanced_visuals = response.data.advanced_visuals
        commit(types.RECEIVE_ADVANCED_VISUALS, advanced_visuals)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getAdvancedVisual ({ commit, dispatch }, advancedVisualId) {
    api.instance.get('/advanced_visuals/' + advancedVisualId)
      .then(function (response) {
        commit(types.RECEIVE_ADVANCED_VISUAL, response.data.advanced_visual)
      })
  },
  addEditAdvancedVisual ({ commit, dispatch }, data) {
    let advanced_visual = data.advanced_visual

    if (advanced_visual.name === '') {
      alert('A name for the visual is required.')
      return
    }

    if (advanced_visual.advanced_visual_id == 0) {
      return api.instance.post('/advanced_visuals', advanced_visual)
        .then(function (response) {
          if (response.data.success === 'true') {
            advanced_visual.advanced_visual_id = response.data.advanced_visual.advanced_visual_id
            commit(types.ADD_ADVANCED_VISUAL, advanced_visual)
            return advanced_visual
          } else {
            alert(response.data.message)
          }
        })
    } else {
      return api.instance.put('/advanced_visuals/' + advanced_visual.advanced_visual_id, advanced_visual)
        .then(function (response) {
          if (response.data.success === 'true') {
            commit(types.EDIT_ADVANCED_VISUAL, advanced_visual)
            // dispatch('getAdvancedVisuals', null, { root: true })
            return advanced_visual
          } else {
            alert(response.data.message)
          }
        })
    }
  },
  deleteAdvancedVisual ({ commit, dispatch }, advanced_visual) {
    return api.instance.delete('/advanced_visuals/' + advanced_visual.advanced_visual_id)
      .then(function (response) {
        commit(types.DELETE_ADVANCED_VISUAL, advanced_visual)
        dispatch('getEventSteps', advanced_visual.event_id, { root: true })
      })
  }
}

const mutations = {
  [types.RECEIVE_ADVANCED_VISUALS] (state, advanced_visuals) {
    state.advanced_visuals = advanced_visuals
  },
  [types.RECEIVE_ADVANCED_VISUAL] (state, advanced_visual) {
    state.advanced_visual = advanced_visual
  },
  [types.ADD_ADVANCED_VISUAL] (state, advanced_visual) {
    state.advanced_visuals.push(advanced_visual)
  },
  [types.EDIT_ADVANCED_VISUAL] (state, advanced_visual) {
    let advancedVisualToEdit = state.advanced_visuals.find(
      function (ele) {
        if (ele.advanced_visual_id === advanced_visual.advanced_visual_id) {
          return true
        }
      }
    )
    let index = state.advanced_visuals.indexOf(advancedVisualToEdit)
    state.advanced_visuals[index] = advanced_visual
  },
  [types.DELETE_ADVANCED_VISUAL] (state, advanced_visual) {
    let advancedVisualToDelete = state.advanced_visuals.find(
      function (ele) {
        if (ele.advanced_visual_id === advanced_visual.advanced_visual_id) {
          return true
        }
      }
    )
    let index = state.advanced_visuals.indexOf(advancedVisualToDelete)
    state.advanced_visuals.splice(index, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
